import * as React from 'react';
import { ModalContext } from 'store/contexts/ModalContext/ModalContext.provider';

export const useModals = () => {
  const ctx = React.useContext(ModalContext);
  if (!ctx) throw new Error('useModals must be used within ModalsProvider');
  return ctx;
};
